import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

const ArticleGlobal = ({ children, className }) => (
	<Container className="py-4">
		<Row className="justify-content-center">
			<Card className={`p-3 shadow-sm ${className || ""}`}>
				{children}{" "}
			</Card>
		</Row>
	</Container>
);

export default ArticleGlobal;
